/**
 * PGSS-5791: split a multi-select filter value back into its choices.
 *
 * Choices are joined with a bare comma ("A,B"). A choice can contain a comma itself: every
 * customer-facing sand blast / etch status does, always followed by a space ("Ready for Sand blast,
 * Etch Production"). Splitting on every comma cut it in two, so only a comma that is not followed by
 * whitespace separates two choices. The API splits the same way (StatusFilterValues).
 */
export function splitFilterValues(value) {
  return String(value).split(/,(?!\s)/);
}
